import AuthContext from 'app/context/AuthContext';
import { useContext } from 'react';

const useAuth = () => useContext(AuthContext)

export default useAuth;